import Thumb from './thumb';

export default class ThumbGroupImage extends Thumb {
  constructor (parameters) {
    super();

    this.height = null; // Just make it undefined
    this.href = null;
    this.description = null;
    this.thumb = null;
    this.isDragable = false;
    this.setValues(parameters);
  }

  getA () {
    return '<a style="height: ' + this.height + 'px; width: ' + this.width + 'px; " id="' + this.uuid + '" class="menu" role="tab" data-id="' + this.id + '" data-toggle="tab" href="' + this.href + '"' + this.getTooltipHtml() + '></a>';
  }

  getItem () {
    const $container = this.getItemContainer();
    const $a = $container.find('a');

    this.name && setThumbLabel(this.name);
    setRightSizeThumbBackground(this.thumb);

    return $container;

    function setRightSizeThumbBackground (url) {
      setThumbBackground(url, 100);

      const thumb = new Image();
      thumb.src = url;
      thumb.onload = function () {
        const containerRatio = $a.width() / $a.height();
        const imageRatio = this.width / this.height;

        const difference = imageRatio / containerRatio;
        imageRatio > containerRatio && setThumbBackground(url, difference * 100);
      };
    }

    function setThumbBackground (url, percentage) {
      $a.css('background', 'url(' + url + ') 50% 50% no-repeat')
        .css('background-size', percentage + '%');
    }

    function setThumbLabel (name) {
      const label = '<p><label>' + name.trimToLength(15) + '</label></p>';
      $a.after(label);
    }
  }
}
